import { observer } from 'mobx-react-lite'
import { useEffect, useMemo } from 'react'
import axios from 'axios'
import { useLocation } from 'react-router-dom'
import { useStore } from '~/app/store'
import { PRODUCTS_TABLE_CONFIG } from '~/entities/products'
import { abortControllerEffect } from '~/shared/lib'
import { TableContainer } from '~/shared/ui/table'
import GoToTop from '~/features/scroll-to-top'
import { SubRowComponentFirst } from '~/entities/products/ui/sub-content-product-1'
import { usePaginationTrigger } from '~/shared/lib/hooks/use-pagination-trigger'
import { useErrorHandler } from '~/shared/lib/hooks/use-error-handler'

export const ProductsTableWidget = observer(() => {
  const { productsStore } = useStore()
  const { handleErrorWithToast } = useErrorHandler()
  const { search } = useLocation()

  const searchWithoutPluses = useMemo(
    () => search.replace(/\+/g, ' '),
    [search],
  )

  const {
    productsLoading,
    products,
    loadingMoreProducts,
    requestSettings,
    getProducts,
    loadProducts,
    productsSubContentOpens,
  } = productsStore

  const { isVisible, anchor } = usePaginationTrigger([
    productsLoading,
    loadingMoreProducts,
  ])

  useEffect(
    () =>
      abortControllerEffect((signal) => {
        getProducts(searchWithoutPluses, signal).catch((error) => {
          if (axios.isCancel(error)) {
            return
          }
          handleErrorWithToast(error)
        })
      }),
    [searchWithoutPluses, getProducts, handleErrorWithToast],
  )

  useEffect(() => {
    if (
      isVisible &&
      products.length &&
      !loadingMoreProducts &&
      !requestSettings.isAllLoaded
    ) {
      loadProducts(searchWithoutPluses).catch(handleErrorWithToast)
    }
  }, [
    isVisible,
    products.length,
    loadingMoreProducts,
    requestSettings.isAllLoaded,
    loadProducts,
    handleErrorWithToast,
    searchWithoutPluses,
  ])

  return (
    <>
      <div className="mt-4">
        <TableContainer
          fixedWidth
          loadMore={loadingMoreProducts}
          isLoading={productsLoading}
          columns={PRODUCTS_TABLE_CONFIG}
          data={products}
          hasSubRowContent
          subRowComponent={SubRowComponentFirst}
          isSubRowOpen={(row) => productsSubContentOpens.includes(row.id)}
        />
        {anchor}
      </div>
      <GoToTop />
    </>
  )
})
